/**
 * Герои MLBB: игровой hero_id → имя (таблица Moonton «英雄Hero», id 1–133).
 * Запасной вариант на случай, если справочник с бэка (client/mlbb/heroes) не загрузился:
 * только имена, без картинок.
 */
export const MLBB_HEROES = Object.freeze({
    1: 'Miya',
    2: 'Balmond',
    3: 'Saber',
    4: 'Alice',
    5: 'Nana',
    6: 'Tigreal',
    7: 'Alucard',
    8: 'Karina',
    9: 'Akai',
    10: 'Franco',
    11: 'Bane',
    12: 'Bruno',
    13: 'Clint',
    14: 'Rafaela',
    15: 'Eudora',
    16: 'Zilong',
    17: 'Fanny',
    18: 'Layla',
    19: 'Minotaur',
    20: 'Lolita',
    21: 'Hayabusa',
    22: 'Freya',
    23: 'Gord',
    24: 'Natalia',
    25: 'Kagura',
    26: 'Chou',
    27: 'Sun',
    28: 'Alpha',
    29: 'Ruby',
    30: 'Yi Sun-shin',
    31: 'Moskov',
    32: 'Johnson',
    33: 'Cyclops',
    34: 'Estes',
    35: 'Hilda',
    36: 'Aurora',
    37: 'Lapu-Lapu',
    38: 'Vexana',
    39: 'Roger',
    40: 'Karrie',
    41: 'Gatotkaca',
    42: 'Harley',
    43: 'Irithel',
    44: 'Grock',
    45: 'Argus',
    46: 'Odette',
    47: 'Lancelot',
    48: 'Diggie',
    49: 'Hylos',
    50: 'Zhask',
    51: 'Helcurt',
    52: 'Pharsa',
    53: 'Lesley',
    54: 'Jawhead',
    55: 'Angela',
    56: 'Gusion',
    57: 'Valir',
    58: 'Martis',
    59: 'Uranus',
    60: 'Hanabi',
    61: "Chang'e",
    62: 'Kaja',
    63: 'Selena',
    64: 'Aldous',
    65: 'Claude',
    66: 'Vale',
    67: 'Leomord',
    68: 'Lunox',
    69: 'Hanzo',
    70: 'Belerick',
    71: 'Kimmy',
    72: 'Thamuz',
    73: 'Harith',
    74: 'Minsitthar',
    75: 'Kadita',
    76: 'Faramis',
    77: 'Badang',
    78: 'Khufra',
    79: 'Granger',
    80: 'Guinevere',
    81: 'Esmeralda',
    82: 'Terizla',
    83: 'X.Borg',
    84: 'Ling',
    85: 'Dyrroth',
    86: 'Lylia',
    87: 'Baxia',
    88: 'Masha',
    89: 'Wanwan',
    90: 'Silvanna',
    91: 'Cecilion',
    92: 'Carmilla',
    93: 'Atlas',
    94: 'Popol and Kupa',
    95: 'Yu Zhong',
    96: 'Luo Yi',
    97: 'Benedetta',
    98: 'Khaleed',
    99: 'Barats',
    100: 'Brody',
    101: 'Yve',
    102: 'Mathilda',
    103: 'Paquito',
    104: 'Gloo',
    105: 'Beatrix',
    106: 'Phoveus',
    107: 'Natan',
    108: 'Aulus',
    109: 'Aamon',
    110: 'Valentina',
    111: 'Edith',
    112: 'Floryn',
    113: 'Yin',
    114: 'Melissa',
    115: 'Xavier',
    116: 'Julian',
    117: 'Fredrinn',
    118: 'Joy',
    119: 'Novaria',
    120: 'Arlott',
    121: 'Ixia',
    122: 'Nolan',
    123: 'Cici',
    124: 'Chip',
    125: 'Zhuxin',
    126: 'Suyou',
    127: 'Lukas',
    128: 'Kalea',
    129: 'Zetian',
    130: 'Obsidia',
    131: 'Sora',
    132: 'Marcel',
    133: 'Hirara',
})

export const heroName = (id) => MLBB_HEROES[id] || null
